var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$paymentsModuleEnabled && _vm.$userIsAdmin
      ? _c("div", { staticClass: "dashboard-block" }, [
          _vm.bookingBookedDepositUnpaid
            ? _c("div", { staticClass: "alert alert-icon alert-info" }, [
                _c("i", { staticClass: "fa fa-exclamation" }),
                _vm._v("\n        Deposit unpaid\n      "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.bookingBookedDepositSent
            ? _c("div", { staticClass: "alert alert-icon alert-info" }, [
                _c("i", { staticClass: "fa fa-exclamation" }),
                _vm._v(
                  "\n        Deposit sent but not marked as received\n      "
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm.$userIsClient ? _c("h2", [_vm._v("What happens next")]) : _vm._e(),
        _vm._v(" "),
        !_vm.$vlastMode && _vm.bookingTermsAreNotAccepted && _vm.$userIsClient
          ? _c("booking-alert-terms-and-conditions")
          : _vm._e(),
        _vm._v(" "),
        _vm.isShoutout && !_vm.booking.video_access_token && _vm.$userIsClient
          ? _c("campaign-notification", {
              attrs: {
                theme: "light",
                icon: "check-circle",
                title: "Video Shout-outs",
                "has-buttons": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "summary",
                    fn: function () {
                      return [
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "The " +
                                _vm._s(_vm.$starLabel) +
                                " will aim to have your video to you within 3 days."
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "If for some reason they can't get it to you within 10 days, PickStar will process your refund"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "You will receive an email and text when your video is ready for download, as well as progress update emails"
                            ),
                          ]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                4189753918
              ),
            })
          : _vm.isShoutout && _vm.booking.video_access_token
          ? _c("campaign-notification", {
              attrs: {
                theme: "light",
                icon: "bullhorn",
                title: "View your shoutout",
                "has-buttons": false,
              },
              scopedSlots: _vm._u([
                {
                  key: "summary",
                  fn: function () {
                    return [
                      _vm._v("\n        Click "),
                      _c(
                        "a",
                        {
                          staticClass: "cursor-pointer",
                          attrs: { target: "_blank", href: _vm.videoLink },
                        },
                        [_vm._v("here")]
                      ),
                      _vm._v(" to view\n      "),
                    ]
                  },
                  proxy: true,
                },
              ]),
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isShoutout && !_vm.booking.video_access_token && _vm.$userIsTalent
          ? _c("campaign-notification", {
              attrs: {
                theme: "light",
                icon: "check-circle",
                title: "Video Shout-outs",
                heading: `To complete this booking, you'll need to use the ${this.clientName} app.`,
                "app-links": true,
                "has-buttons": false,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.$paymentsModuleEnabled &&
        (!_vm.$user.has_mobile_app || _vm.bookingPaymentDepositIsUnpaid) &&
        !_vm.isShoutout &&
        _vm.$userIsClient
          ? _c("div", { staticClass: "cta-card" }, [
              _c("img", {
                staticClass: "cta-card__image margin-none",
                attrs: { src: require("assets/img/chat-unlocked.jpg") },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col cta-card__body" }, [
                _vm.bookingPaymentDepositIsUnpaid
                  ? _c(
                      "div",
                      [
                        _c("div", { staticClass: "spacer-b-2" }, [
                          _c("p", { staticClass: "cta-card__heading" }, [
                            _c("strong", [
                              _vm._v(
                                "Confirm the booking to chat directly to your " +
                                  _vm._s(_vm.$starLabel) +
                                  "!"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "cta-card__sub" }, [
                            _vm._v(
                              "Pay your deposit, download our Mobile App and chat to the " +
                                _vm._s(_vm.$starLabel) +
                                "."
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-primary btn-sm",
                            staticStyle: { width: "fit-content" },
                            attrs: {
                              to: {
                                name: "payments.show",
                                params: {
                                  bookingId: _vm.booking.id,
                                  action: "process",
                                  paymentId: _vm.bookingPaymentDeposit.id,
                                  props: { default: true, showMessage: false },
                                },
                              },
                            },
                          },
                          [_vm._v("\n            Pay Now\n          ")]
                        ),
                      ],
                      1
                    )
                  : _c("div", [
                      _c("div", { staticClass: "spacer-b-2" }, [
                        _c("p", { staticClass: "cta-card__heading" }, [
                          _c("strong", [
                            _vm._v(
                              "Your booking is confirmed, time to chat to the " +
                                _vm._s(_vm.$starLabel) +
                                " about the details!"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "cta-card__sub" }, [
                          _vm._v(
                            "Download our Mobile App and chat to the " +
                              _vm._s(_vm.$starLabel) +
                              " now!"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$paymentsModuleEnabled &&
        !_vm.bookingPaymentDepositIsUnpaid &&
        _vm.bookingPaymentFinalIsUnpaid &&
        _vm.$userIsClient
          ? _c("BookingAlertUnpaidFinal")
          : _vm._e(),
        _vm._v(" "),
        !_vm.$vlastMode
          ? _c("booking-terms-and-conditions-modal", {
              ref: "terms",
              attrs: {
                booking: _vm.booking,
                talents: _vm.bookingAttendingTalent,
                "property-mutator": _vm.setRequestProperty,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.bookingTypeIsBookingRequest && _vm.bookingHasExpired
      ? _c("div", { staticClass: "alert alert-danger alert-icon" }, [
          _c("i", { staticClass: "fa fa-frown-o" }),
          _vm._v(" "),
          _vm.bookingHaveNoAppliedTalent
            ? _c("span", [
                _vm._v(
                  "\n      You did not have any responses in time. Feel free to change your request or contact the " +
                    _vm._s(_vm.clientName) +
                    " team for advice.\n    "
                ),
              ])
            : _c("span", [
                _vm._v(
                  "\n      Unfortunately your booking has expired. Contact the " +
                    _vm._s(_vm.clientName) +
                    " team for advice.\n    "
                ),
              ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex items-center" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://itunes.apple.com/au/app/pickstar-sports-talent/id1425719956?mt=8",
            target: "_blank",
          },
        },
        [
          _c("img", {
            staticStyle: { height: "40px", width: "auto", "max-width": "none" },
            attrs: {
              alt: "Download in App Store",
              src: "https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2018-10-06&kind=iossoftware&bubble=ios_apps",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://play.google.com/store/apps/details?id=pickstar.com.au.talent&hl=en_AU",
            target: "_blank",
          },
        },
        [
          _c("img", {
            staticStyle: { height: "60px", width: "auto", "max-width": "none" },
            attrs: {
              alt: "Get it on Google Play",
              src: "https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png",
            },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }